import { useLanguage } from "../i18n/LanguageContext";
import { SUPPORTED_LANGUAGES, isSupportedLanguage } from "../i18n/languages";

/**
 * Header dropdown letting a visitor override the auto-detected/remembered
 * language (see LanguageContext) at any time - options are listed by their
 * OWN native name (e.g. "Deutsch", "日本語"), not translated into the
 * currently active language, so a visitor can always find their language by
 * eye even if the current UI language is one they don't read at all.
 */
export function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();

  return (
    <label className="flex items-center gap-1.5 text-sm text-slate-600">
      <span className="sr-only">{t("language.switcherLabel")}</span>
      <span aria-hidden="true">🌐</span>
      <select
        value={language}
        onChange={(e) => {
          const next = e.target.value;
          if (isSupportedLanguage(next)) setLanguage(next);
        }}
        aria-label={t("language.switcherLabel")}
        className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm text-slate-700 hover:bg-slate-50 focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.nameNative}
          </option>
        ))}
      </select>
    </label>
  );
}
